export default __webpack_public_path__ + "static/media/pencil-light.f6da782c.svg";